export default () => {
  return {
    isTouchDevice: false,
    isIntersecting: false,

    init() {
      this.checkTouchDevice();
    },
    checkTouchDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        this.isTouchDevice = true;
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.isTouchDevice = true;
      }
    },
  };
};
